import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import logolight from "../../assets/images/CentoFin.png";
import logodark from "../../assets/images/CentoFin.png";
import { useNavigate } from "react-router-dom";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//redux
// import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { postApi } from "../../helpers/Api/Index";
import config from "../../config";
import { AppContext } from "../../components/common/Helpers/Context/AppContext";
import { Grid } from "@mui/material";
import wiprocarelogo from "../../assets/images/wiprocares.png"

//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
// import { loginUser, socialLogin } from "../../store/actions";

//Import config
const baseUrl = config.baseUrl;


const Login = (props: any) => {
  const { globalData, setGlobalData } = useContext(AppContext);
  const [alert, setAlert] = useState('');
  const navigate = useNavigate();

  const [error, setError] = React.useState();
  // const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      user_name: '',
      password: '',
    },
    validationSchema: Yup.object({
      user_name: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      postApi(baseUrl + '/auth/login', values).then((res: any) => {
        if (Number(res.data.role_id) === 0) {
          localStorage.removeItem('loginData');
          setAlert("Username/ Password is invalid!")
        } else {
          localStorage.setItem('loginData', JSON.stringify(res.data))
          localStorage.setItem('token', res.token)
          toast.success("Login Successfully!")
          setGlobalData({
            ...globalData,
            data: res.data,
            isLoggedIn: true
          })
          navigate("/");
        }
        // dispatch(loginUser(values, props.router.navigate));
      }
      ).catch(error => {
        setAlert(error)
        setTimeout(() => {
          setAlert("")
        }, 3000)
        console.log(error);
      })
    }
  });

  // const { error } = useSelector(state => ({
  //   error: state.login.error,
  // }));

  // handleValidSubmit
  // const handleValidSubmit = (event, values) => {
  //   dispatch(loginUser(values, props.router.navigate));
  // };

  // const signIn = (res:any, type:any) => {
  //   if (type === "google" && res) {
  //     const postData = {
  //       name: res.profileObj.name,
  //       email: res.profileObj.email,
  //       token: res.tokenObj.access_token,
  //       idToken: res.tokenId,
  //     };
  //     // dispatch(socialLogin(postData, props.router.navigate, type));
  //   } else if (type === "facebook" && res) {
  //     const postData = {
  //       name: res.name,
  //       email: res.email,
  //       token: res.accessToken,
  //       idToken: res.tokenId,
  //     };
  //     // dispatch(socialLogin(postData, props.router.navigate, type));
  //   }
  // };

  //handleGoogleLoginResponse
  // const googleResponse = (response:any) => {
  //   signIn(response, "google");
  // };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  // const facebookResponse = (response:any) => {
  //   signIn(response, "facebook");
  // };

  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  useEffect(() => {
    let loginData = localStorage.getItem('loginData');
    if (loginData) {
      setGlobalData({
        ...globalData,
        data: JSON.parse(loginData),
        isLoggedIn: true
      })
      navigate("/");
    }

  }, [])

  return (
    <React.Fragment>

      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="text-center">
                          <Link to="/">
                            <img
                              src={logodark}
                              alt="" width={100}
                              // height="34"
                              className="auth-logo logo-dark mx-auto"
                            />
                            <img
                              src={logolight}
                              alt=""
                              // height="34"
                              className="auth-logo logo-light mx-auto"
                            />
                          </Link>
                        </div>
                      </Grid>
                    </Grid>
                  </div>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {error ? <Alert color="danger"><div>{error}</div></Alert> : null}
                    <Row>
                      <Col md={12}>
                        <div className="mb-4">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="user_name"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.user_name || ""}
                            invalid={
                              validation.touched.user_name && validation.errors.user_name ? true : false
                            }
                          />
                          {validation.touched.user_name && validation.errors.user_name ? (
                            <FormFeedback type="invalid"><div>{validation.errors.user_name}</div></FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-4">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid"><div> {validation.errors.password} </div></FormFeedback>
                          ) : null}
                        </div>

                        <Row>
                          <Col>

                          </Col>

                        </Row>
                        {
                          alert ? <Alert show={true} color="danger">
                            {alert}
                          </Alert> : null
                        }

                        <div className="d-grid mt-4">
                          <button
                            className="btn btn-primary waves-effect waves-light"
                            type="submit"
                          >
                            Log In
                          </button>
                        </div>


                      </Col>
                    </Row>
                  </Form>
                  {/* </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
